import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

import {useGetTrafficOverTimeReport} from '../graphql/hooks';
import {sortBucketsAndAddStarAndFill} from '../helpers';

import {ChartCard, ChartHeader, TrafficOverTimeLineChart} from '.';

type Props = {
    website: string;
};

export function TrafficOverTimeWrapper(props: Props) {
    const {
        trafficOverTimeData,
        isError: trafficOverTimeError,
        isLoading: trafficOverTimeLoading,
    } = useGetTrafficOverTimeReport();

    const domainsOverTime = trafficOverTimeData
        ? sortBucketsAndAddStarAndFill(trafficOverTimeData, props.website)
        : [];
    const trafficOverTimeStartMonth =
        domainsOverTime && domainsOverTime[0] && domainsOverTime[0].segments
            ? domainsOverTime[0].segments[0].bucket
            : '';
    const trafficOverTimeEndMonth =
        domainsOverTime && domainsOverTime[0] && domainsOverTime[0].segments
            ? domainsOverTime[0].segments[domainsOverTime[0].segments.length - 1].bucket
            : '';
    const hasFullCompetitorIq = NutClientConfig.hasFullCompetitorIq;

    return (
        <StackLegacy spacing={16}>
            <ChartHeader
                headerTitle='Competitor traffic trends'
                headerBody='Track and analyze competitors’ traffic trends over time for informed decision-making'
                downloadReportTitle={`CompetitorSpy traffic over time report for ${trafficOverTimeStartMonth} to
                            ${trafficOverTimeEndMonth}`}
            />
            <ChartCard
                isLoading={trafficOverTimeLoading}
                isError={trafficOverTimeError}
                content={
                    <TrafficOverTimeLineChart website={props.website} domains={domainsOverTime} />
                }
                promoStateOverlay={
                    hasFullCompetitorIq ? undefined : (
                        <PromoStateOverlay
                            promoStateProps={{
                                isHorizontal: true,
                                imageUrl: '/include/images/onboarding/analytics-info.svg',
                                title: 'Track and analyze competitors’ web traffic trends over time',
                                subtitle:
                                    'Analyze how your competitors are gaining or losing traction with Marketing Pro.',
                                primaryCta: {
                                    text: 'Learn more',
                                    url: 'https://support.nutshell.com/en/articles/8561063-competitorspy-stay-one-step-ahead-of-the-game-with-competitor-website-insights',
                                    isExternalLink: true,
                                },
                                secondaryCta: {
                                    text: 'View plans',
                                    url: '/setup/billing/sales',
                                },
                            }}
                        />
                    )
                }
            />
        </StackLegacy>
    );
}
